import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import PasswordInput from "@/components/PasswordInput";
import PasswordRequirements from "@/components/PasswordRequirements";
import { isPasswordValid } from "@/lib/passwordRules";

// Ganti kata sandi mandiri (POST /auth/change-password lewat AuthContext.changePassword,
// sama dgn ForcePasswordChange.jsx). Sesi lain otomatis tercabut oleh server; sesi ini
// tetap jalan krn token barunya disimpan changePassword.
export default function GantiKataSandiCard() {
    const { changePassword } = useAuth();
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);
    const [resetKey, setResetKey] = useState(0);

    const submit = async (e) => {
        e.preventDefault();
        if (!isPasswordValid(next)) return toast.error("Kata sandi baru belum memenuhi semua syarat di bawah");
        if (next !== confirm) return toast.error("Konfirmasi kata sandi tidak cocok");
        setLoading(true);
        const res = await changePassword(current, next);
        setLoading(false);
        setResetKey((k) => k + 1);
        if (!res.ok) return toast.error(res.error);
        setCurrent(""); setNext(""); setConfirm("");
        toast.success("Kata sandi berhasil diganti");
    };

    return (
        <Card className="border-slate-200 shadow-sm">
            <CardContent className="p-6">
                <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-teal-50 flex items-center justify-center shrink-0">
                        <KeyRound className="w-5 h-5 text-[#00877D]" />
                    </div>
                    <div>
                        <div className="font-semibold text-slate-800">Ganti Kata Sandi</div>
                        <p className="text-xs text-slate-500">Sesi di perangkat lain akan otomatis keluar.</p>
                    </div>
                </div>
                <form onSubmit={submit} className="space-y-4" data-testid="ganti-sandi-form">
                    <div>
                        <Label className="text-xs font-semibold uppercase tracking-wide text-slate-700">Kata Sandi Saat Ini</Label>
                        <PasswordInput key={`cur-${resetKey}`} required autoComplete="current-password" value={current}
                            onChange={(e) => setCurrent(e.target.value)} className="mt-1.5 h-11" data-testid="ganti-sandi-current" />
                    </div>
                    <div>
                        <Label className="text-xs font-semibold uppercase tracking-wide text-slate-700">Kata Sandi Baru</Label>
                        <PasswordInput key={`new-${resetKey}`} required minLength={8} autoComplete="new-password" value={next}
                            onChange={(e) => setNext(e.target.value)} className="mt-1.5 h-11" data-testid="ganti-sandi-new" />
                        <PasswordRequirements password={next} />
                    </div>
                    <div>
                        <Label className="text-xs font-semibold uppercase tracking-wide text-slate-700">Konfirmasi Kata Sandi Baru</Label>
                        <PasswordInput key={`conf-${resetKey}`} required minLength={8} autoComplete="new-password" value={confirm}
                            onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-11" data-testid="ganti-sandi-confirm" />
                    </div>
                    <Button type="submit" disabled={loading} className="h-11 bg-[#00B9AD] hover:bg-[#60C0D0]" data-testid="ganti-sandi-submit">
                        {loading ? "Menyimpan..." : "Simpan Kata Sandi"}
                    </Button>
                </form>
            </CardContent>
        </Card>
    );
}
